import { render, staticRenderFns } from "./editor_textContext.vue?vue&type=template&id=d939fbf8&scoped=true"
import script from "./editor_textContext.vue?vue&type=script&lang=js"
export * from "./editor_textContext.vue?vue&type=script&lang=js"
import style0 from "./editor_textContext.vue?vue&type=style&index=0&id=d939fbf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d939fbf8",
  null
  
)

export default component.exports